module.exports = __webpack_public_path__ + "img/37.16e202f3.jpg";